import React, { useState } from 'react';
import Planes from './Planes';
import Carga from './Carga';
import Descarga from './Descarga';
import Cierre from './Cierre';
import Admin from './Admin';
import Analisis from './Analisis';
import Whatsapp from './Whatsapp';

function Dashboard() {
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const [seccionActiva, setSeccionActiva] = useState('inicio');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    window.location.href = '/login';
  };

  const renderContenido = () => {
    switch(seccionActiva) {
      case 'planes': return <Planes />;
      case 'carga': return <Carga />;
      case 'descarga': return <Descarga />;
      case 'cierre': return <Cierre />;
      case 'admin': return <Admin />;
      case 'analisis': return <Analisis />;
      case 'whatsapp': return <Whatsapp />;
      default: return (
        <div style={styles.contenido}>
          <h3 style={styles.bienvenida}>¡Bienvenido, {usuario?.nombre}! 👋</h3>
          <p style={styles.descripcion}>Tu rol es: <strong>{usuario?.rol}</strong></p>
          <div style={styles.tarjetas}>
            {(usuario?.rol === 'encargado' || usuario?.rol === 'asistente') && (
              <div style={styles.tarjeta} onClick={() => setSeccionActiva('planes')}>
                <span style={styles.icono}>📋</span>
                <h4>Planes de Compra</h4>
                <p>Crear y gestionar planes</p>
              </div>
            )}
            {(usuario?.rol === 'carga' || usuario?.rol === 'encargado') && (
              <div style={styles.tarjeta} onClick={() => setSeccionActiva('carga')}>
                <span style={styles.icono}>🚛</span>
                <h4>Carga de Camión</h4>
                <p>Registrar mercadería cargada</p>
              </div>
            )}
            {(usuario?.rol === 'descarga' || usuario?.rol === 'encargado') && (
              <div style={styles.tarjeta} onClick={() => setSeccionActiva('descarga')}>
                <span style={styles.icono}>📦</span>
                <h4>Descarga</h4>
                <p>Registrar mercadería recibida</p>
              </div>
            )}
            {usuario?.rol === 'encargado' && (
              <div style={styles.tarjeta} onClick={() => setSeccionActiva('cierre')}>
                <span style={styles.icono}>✅</span>
                <h4>Cierre de Compras</h4>
                <p>Validar y cerrar compras</p>
              </div>
            )}
            {usuario?.rol === 'encargado' && (
              <div style={styles.tarjeta} onClick={() => setSeccionActiva('analisis')}>
                <span style={styles.icono}>📊</span>
                <h4>Análisis</h4>
                <p>Estadísticas y reportes</p>
              </div>
            )}
            {usuario?.rol === 'encargado' && (
              <div style={styles.tarjeta} onClick={() => setSeccionActiva('admin')}>
                <span style={styles.icono}>⚙️</span>
                <h4>Administración</h4>
                <p>Productos, proveedores y vacíos</p>
              </div>
            )}
            {usuario?.rol === 'encargado' && (
              <div style={styles.tarjeta} onClick={() => setSeccionActiva('whatsapp')}>
                <span style={styles.icono}>📱</span>
                <h4>WhatsApp</h4>
                <p>Mensajes y recordatorios</p>
              </div>
            )}
          </div>
        </div>
      );
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.headerIzquierda}>
          <h2 style={styles.titulo}>🛒 Mercado Compras</h2>
          {seccionActiva !== 'inicio' && (
            <button style={styles.botonVolver} onClick={() => setSeccionActiva('inicio')}>
              ← Volver
            </button>
          )}
        </div>
        <div style={styles.headerDerecha}>
          <span style={styles.nombreUsuario}>👤 {usuario?.nombre}</span>
          <span style={styles.rol}>{usuario?.rol}</span>
          <button style={styles.botonSalir} onClick={handleLogout}>
            Cerrar sesión
          </button>
        </div>
      </div>
      {renderContenido()}
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', backgroundColor: '#f0f2f5' },
  header: { backgroundColor: '#27ae60', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  headerIzquierda: { display: 'flex', alignItems: 'center', gap: '20px' },
  titulo: { color: 'white', margin: 0 },
  botonVolver: { backgroundColor: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid white', padding: '6px 15px', borderRadius: '6px', cursor: 'pointer' },
  headerDerecha: { display: 'flex', alignItems: 'center', gap: '15px' },
  nombreUsuario: { color: 'white', fontWeight: 'bold' },
  rol: { backgroundColor: 'rgba(255,255,255,0.3)', color: 'white', padding: '4px 10px', borderRadius: '20px', fontSize: '12px' },
  botonSalir: { backgroundColor: 'white', color: '#27ae60', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' },
  contenido: { padding: '30px' },
  bienvenida: { color: '#2c3e50', fontSize: '24px' },
  descripcion: { color: '#7f8c8d', marginBottom: '30px' },
  tarjetas: { display: 'flex', gap: '20px', flexWrap: 'wrap' },
  tarjeta: { backgroundColor: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', width: '200px', textAlign: 'center', cursor: 'pointer' },
  icono: { fontSize: '40px' }
};

export default Dashboard;